import {useMutation} from '@tanstack/react-query';
import {SignInParams} from 'domain/usecases';
import {MUTATION_KEYS} from 'infra/libs/react-query/mutationKeys';
import {remoteAuthentication} from '../services/remoteAuthentication';

export const useRemoteAuthenticationMutation = () =>
	useMutation({
		mutationKey: [MUTATION_KEYS.AUTHENTICATION],
		mutationFn: async (params: SignInParams) => remoteAuthentication(params),
	});
